import { apiCall } from "../common";
import * as api from "../../api/generated-api";
import { processUnexpectedError } from "../errors";

export const getDealInvestorDealLegalEntityInvestments = (
  orgId: number,
  dealId: number,
  dealInvestorId: number,
  successCallback?: (investment: api.DealLegalEntityInvestment[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLegalEntityInvestment[]>(
    () => {
      return api.getDealInvestorDealLegalEntityInvestments(
        orgId,
        dealId,
        dealInvestorId
      );
    },
    successCallback,
    errorCallback
  );
};

export const createDealLegalEntityInvestment = (
  orgId: number,
  dealId: number,
  dealInvestorId: number,
  createData: api.DealLegalEntityInvestmentCreate,
  successCallback?: (investment: api.DealLegalEntityInvestment) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLegalEntityInvestment>(
    () => {
      return api.createDealLegalEntityInvestment(
        orgId,
        dealId,
        dealInvestorId,
        createData
      );
    },
    successCallback,
    errorCallback
  );
};

export const createDealLegalEntityInvestments = (
  orgId: number,
  dealId: number,
  dealInvestorId: number,
  createData: api.DealLegalEntityInvestmentCreate[],
  successCallback?: (investment: api.DealLegalEntityInvestment[]) => void,
  errorCallback?: (error: Error) => void
) => {
  let createInvestmentsError: Error;
  const createInvestmentsErrorCallback = (error: Error) => {
    createInvestmentsError = error;
  };

  const successfulInvestments: api.DealLegalEntityInvestment[] = [];
  const createInvestmentsSuccessCallback = (
    investment: api.DealLegalEntityInvestment
  ) => {
    successfulInvestments.push(investment);
  };

  createData.forEach((data) => {
    createDealLegalEntityInvestment(
      orgId,
      dealId,
      dealInvestorId,
      data,
      createInvestmentsSuccessCallback,
      createInvestmentsErrorCallback
    );
  });

  if (createInvestmentsError && errorCallback) {
    errorCallback(createInvestmentsError);
  } else if (createInvestmentsError && !errorCallback) {
    processUnexpectedError(createInvestmentsError);
  }

  if (successfulInvestments.length > 0 && successCallback) {
    successCallback(successfulInvestments);
  }
};

export const deleteDealLegalEntityInvestment = (
  orgId: number,
  dealId: number,
  dealInvestorId: number,
  dealLegalEntityInvestmentId: number,
  successCallback?: () => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<void>(
    () => {
      return api.deleteDealLegalEntityInvestment(
        orgId,
        dealId,
        dealInvestorId,
        dealLegalEntityInvestmentId
      );
    },
    successCallback,
    errorCallback
  );
};
